<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    :title="title"
    size="xl"
    @close="close"
  >
    <EditRowForm
      :gridId="gridId"
      :rowKey="rowKey"
      @submit="close"
    />
    <div>
      <b-button
        variant="success"
        @click="close()"
      >
        Done
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// components
import EditRowForm from '@/components/DataGrid/forms/EditRow'

// helpers
import eventBus from '@/helpers/event-bus'

export default {
  components: {
    EditRowForm
  },
  data () {
    return {
      gridId: null,
      rowKey: null
    }
  },
  computed: {
    ...mapState([
      'dataGrid_options'
    ]),
    title () {
      if (!this.exists()) return null

      const gridTitle = this.dataGrid_options[this.gridId].title

      return `Edit "${gridTitle}" `
    }
  },
  methods: {
    open (gridId, rowKey) {
      this.gridId = gridId
      this.rowKey = rowKey

      if (this.$refs.modal) this.$refs.modal.show()
    },
    close () {
      eventBus.$emit('editRowFormClosed', {})
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    exists () {
      if (!this.gridId || !this.dataGrid_options) return false
      if (!this.dataGrid_options[this.gridId]) return false
      return true
    }
  }
}
</script>
